import { render, staticRenderFns } from "./pc-input-date.vue?vue&type=template&id=252719a4"
import script from "./pc-input-date.vue?vue&type=script&lang=ts"
export * from "./pc-input-date.vue?vue&type=script&lang=ts"
import style0 from "./pc-input-date.vue?vue&type=style&index=0&id=252719a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports